/**
 * A ordem das abas do acesso rápido, SEM entrada repetida.
 *
 * ## O aviso do React que isto apaga
 *
 * > Encountered two children with the same key, `ia-base-conhecimento`
 *
 * A barra de abas é desenhada percorrendo `quickAccessGlobalOrder`
 * (localStorage) e, para cada entrada, procurando o item correspondente. A
 * entrada repetida faz a MESMA aba ser desenhada duas vezes, com a mesma
 * `key` -- e aí o React avisa que pode duplicar ou omitir filhos. Na prática:
 * aba repetida na barra, e fechar uma pode fechar a errada.
 *
 * ## Como a repetição aparecia
 *
 * Duas escritas disputam `quickAccessGlobalOrder` nos primeiros 100 ms:
 *
 * - o auto-add, ao entrar numa página, fazia `[...prev, entrada]` sem olhar se
 *   a entrada já estava lá (a verificação olhava a lista de PÁGINAS, no outro
 *   endereço do localStorage, não a ordem);
 * - a inicialização da ordem, num `setTimeout(..., 100)`, SOBRESCREVE a ordem
 *   inteira com tudo que existe.
 *
 * Se a sobrescrita chega primeiro e o append depois, a entrada fica duas
 * vezes. Daí em diante está gravada no navegador e o aviso repete em todo
 * render -- é por isso que ele aparecia "várias vezes".
 *
 * As duas pontas foram consertadas, e esta função é a garantia: a barra não
 * desenha entrada repetida nem se um terceiro escritor aparecer amanhã.
 */

/** A identidade de uma entrada da ordem: o par tipo + item. */
const identidade = (entrada) => `${entrada.typeId}\u0000${entrada.itemId}`;

export const ordemDoAcessoRapido = (entradas) => {
    if (!Array.isArray(entradas)) return [];

    const vistas = new Set();

    return entradas.filter((entrada) => {
        if (!entrada || entrada.typeId === undefined || entrada.itemId === undefined) return false;

        const chave = identidade(entrada);
        if (vistas.has(chave)) return false;

        vistas.add(chave);
        return true;
    });
};

/** A entrada já está na ordem? Usado para o append ser idempotente. */
export const jaEstaNaOrdem = (entradas, typeId, itemId) =>
    (Array.isArray(entradas) ? entradas : []).some(
        (entrada) => entrada && entrada.typeId === typeId && entrada.itemId === itemId
    );
